import { render, staticRenderFns } from "./PrivateDiscussionInstagram.vue?vue&type=template&id=4c446394&"
import script from "./PrivateDiscussionInstagram.vue?vue&type=script&lang=js&"
export * from "./PrivateDiscussionInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports